import { Component, OnInit } from '@angular/core'
import { UserProfilePasswordReset } from '../../models/user-profile-password-reset'
import { UserProfile } from '../../models/user-profile'
import { CurrentUser } from '../../../common/models/current-user'
import { UserProfileGateway } from '../../gateways/user-profile-gateway'
import { Router, ActivatedRoute } from '@angular/router'
import { FormValidationService } from '../../../validations/form-validation-service'
import { UserAccessGateway } from '../../../common/gateways/user-access-gateway'
import { PortalGlobals } from '../../../portalglobals'

@Component({
    selector: 'PasswordReset',
    templateUrl: 'password-reset.component.html'
})
export class PasswordResetComponent implements OnInit {
    validatePassword: boolean
    validateconfirmPassword: boolean
    errorMsg: string
    errorConfMsg: string
    loginId: string
    userProfileID: number
    passwordResetModel: UserProfilePasswordReset
    userProfileModel: UserProfile
    currentUser: CurrentUser
    ErrorMessages: any[] | null
    errorlist: any[]
    errorlists: any[]
    isFormValid: boolean = true
    showSuccessMsg: boolean
    icName: string
    insCo: string

    constructor(
        private userProfileGateway: UserProfileGateway,
        private routers: Router,
        private route: ActivatedRoute,
        private formValidationService: FormValidationService,
        private _networkUserAccessGateway: UserAccessGateway,
        public _global: PortalGlobals
    ) {
        this.userProfileModel = {} as UserProfile
        this.passwordResetModel = {} as UserProfilePasswordReset
        this.currentUser = {} as CurrentUser
        this.route.params.subscribe((params) => {
            if (params['userprofileid']) {
                this.userProfileID = params['userprofileid']
            }
            if (params['insCo']) {
                this.insCo = params['insCo']
            }
        })
    }

    ngOnInit(): void {
        this.showSuccessMsg = false
        this.isFormValid = true
        this.validatePassword = false
        this.validateconfirmPassword = false
        this.userProfileGateway.findUserProfileByProfileID(this.userProfileID).subscribe((model: UserProfile) => {
            this.userProfileModel = model
            console.log(this.userProfileModel)
            this.passwordResetModel.UserProfileName = this.userProfileModel.UserProfileName
            this.passwordResetModel.newPassword = ''
            this.passwordResetModel.confirmPassword = ''
            this._networkUserAccessGateway.getCurrentUser().subscribe((user) => {
                if (user != null) {
                    this.currentUser = user
                    this.icName = this.currentUser.insuranceCompanyName
                    this.insCo = this.currentUser.insuranceCompanyShortName.toLowerCase()
                }
            })
        })
    }

    resetPassword() {
        this.showSuccessMsg = false
        this.isFormValid = true
        this.ErrorMessages = null
        this.errorConfMsg = ''
        this.formValidationService.validateAll(
            () => {
                this.userProfileGateway.updateResetPassword(this.passwordResetModel.newPassword, this.userProfileID).subscribe(
                    (model: Boolean) => {
                        this.showSuccessMsg = true
                        this.validateconfirmPassword = true
                        this.errorConfMsg = 'You have successfully changed the password.'
                        this.isFormValid = true
                        this.passwordResetModel.confirmPassword = ''
                        this.passwordResetModel.newPassword = ''
                    },
                    (error) => {
                        this.isFormValid = false
                        this.errorlist = JSON.parse(error.statusText)
                        this.errorlists = this.errorlist.toString().split(',')
                        this.ErrorMessages = this.errorlists
                        this.isFormValid = false
                    }
                )
            },
            () => {}
        )

        //if (this.passwordResetModel.newPassword !== undefined && this.passwordResetModel.newPassword !== ''
        //    && this.passwordResetModel.newPassword !== null && this.passwordResetModel.confirmPassword !== null
        //    && this.passwordResetModel.confirmPassword === this.passwordResetModel.newPassword) {
        //    this.userProfileGateway.updateResetPassword(this.passwordResetModel.newPassword, this.userProfileID).subscribe(
        //        (model: Boolean) => {
        //            this.validateconfirmPassword = true
        //            this.errorConfMsg = 'You have successfully changed the password.'
        //            this.passwordResetModel.newPassword = null
        //            this.passwordResetModel.confirmPassword = null
        //        })
        //} else {
        //    this.validateconfirmPassword = false
        //    this.validateconfirmPassword = false
        //    if (this.passwordResetModel.newPassword === undefined || this.passwordResetModel.newPassword === ''
        //        || this.passwordResetModel.newPassword === null) {
        //        this.validatePassword = true
        //        this.errorMsg = 'Enter new password'
        //    }
        //    if (this.passwordResetModel.confirmPassword === undefined || this.passwordResetModel.confirmPassword === ''
        //        || this.passwordResetModel.confirmPassword === null) {
        //        this.validateconfirmPassword = true
        //        this.errorConfMsg = 'Enter new password again'
        //    }
        //    if (this.passwordResetModel.newPassword !== undefined && this.passwordResetModel.newPassword !== ''
        //        && this.passwordResetModel.newPassword !== null && this.passwordResetModel.confirmPassword !== null
        //        && this.passwordResetModel.confirmPassword !== this.passwordResetModel.newPassword
        //    ) {
        //        this.validateconfirmPassword = true
        //        this.errorConfMsg = 'The password you entered is incorrect.Please try again.'
        //    }

        //}
    }

    onBlurForObfuscatedText() {
        if (this.passwordResetModel.newPassword === undefined || this.passwordResetModel.newPassword === '') {
            this.validatePassword = true
            this.errorMsg = 'Enter new password'
        } else {
            this.validatePassword = false
        }
    }

    onBlurForObfuscatedconfirmPassword() {
        if (this.passwordResetModel.confirmPassword === undefined || this.passwordResetModel.confirmPassword === '') {
            this.validateconfirmPassword = true
            this.errorConfMsg = 'Enter new password again'
        } else {
            this.validateconfirmPassword = false
        }
    }

    onFocusForObfuscatedText() {}
    cancelData() {
        if (this.icName === this._global.insuranceCompanyNameNEJE) {
            this.routers.navigate(['/' + this.insCo + '/user-management/neje/add-profile', 'edit', this.userProfileID])
        } else {
            this.routers.navigate(['/' + this.insCo + '/user-management/edit-user', 'edit', this.userProfileID])
        }
    }
}
